var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoulombLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 245,
    height: 57,
    viewBox: "0 0 245 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M89.8576 37.5485C88.1541 38.3706 85.9548 38.7816 83.2163 38.7816C79.6585 38.7816 76.8554 37.7215 74.807 35.6231C72.7586 33.5246 71.7451 30.7339 71.7451 27.2292C71.7451 23.5082 72.8879 20.4795 75.1951 18.1647C77.4807 15.8499 80.4563 14.6816 84.122 14.6816C86.386 14.6816 88.3051 14.9629 89.8576 15.547V20.5876C88.3051 19.6574 86.537 19.1815 84.5532 19.1815C82.3754 19.1815 80.6073 19.8737 79.2704 21.2367C77.9335 22.6212 77.2651 24.4817 77.2651 26.8182C77.2651 29.0681 77.8904 30.8637 79.1626 32.2049C80.4348 33.5462 82.1167 34.2169 84.2513 34.2169C86.2998 34.2169 88.1541 33.7193 89.8576 32.7242V37.5485Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.309 38.7825C98.5485 38.7825 96.3707 38.0037 94.7967 36.446C93.2226 34.8884 92.4248 32.7899 92.4248 30.129C92.4248 27.3815 93.2442 25.2181 94.8829 23.6821C96.5217 22.1245 98.7426 21.3457 101.546 21.3457C104.306 21.3457 106.462 22.1245 108.014 23.6821C109.589 25.2398 110.365 27.295 110.365 29.8478C110.365 32.6169 109.567 34.7802 107.95 36.4028C106.333 37.982 104.112 38.7825 101.309 38.7825ZM101.438 25.283C100.23 25.283 99.2817 25.6941 98.6132 26.5378C97.9448 27.3815 97.5998 28.5497 97.5998 30.0857C97.5998 33.2875 98.8935 34.8668 101.459 34.8668C103.918 34.8668 105.125 33.2226 105.125 29.9559C105.147 26.819 103.918 25.283 101.438 25.283Z",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.423 38.3727H124.334V35.8415H124.248C122.976 37.8102 121.294 38.7837 119.181 38.7837C115.343 38.7837 113.424 36.4473 113.424 31.7744V21.7363H118.513V31.3201C118.513 33.6781 119.44 34.8464 121.294 34.8464C122.221 34.8464 122.954 34.5218 123.493 33.8728C124.054 33.2238 124.313 32.3585 124.313 31.2552V21.7363H129.402V38.3727H129.423Z",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.675 32.7465C138.675 33.4604 138.847 33.9796 139.171 34.3474C139.516 34.7152 139.947 34.8882 140.507 34.8882C140.788 34.8882 141.068 34.8666 141.348 34.8017C141.629 34.7368 141.909 34.6935 142.189 34.6286V38.2415C141.564 38.4145 140.917 38.5443 140.249 38.6309C139.559 38.739 138.847 38.7823 138.114 38.7823C137.424 38.7823 136.82 38.6741 136.26 38.4362C135.699 38.1982 135.225 37.8737 134.836 37.4626C134.448 37.03 134.146 36.5108 133.931 35.905C133.715 35.2993 133.607 34.607 133.607 33.8498V13.7305H138.696V32.7465H138.675Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.26 38.7825C149.5 38.7825 147.322 38.0037 145.748 36.446C144.174 34.8884 143.376 32.7899 143.376 30.129C143.376 27.3815 144.195 25.2181 145.834 23.6821C147.473 22.1245 149.694 21.3457 152.497 21.3457C155.257 21.3457 157.413 22.1245 158.966 23.6821C160.54 25.2398 161.316 27.295 161.316 29.8478C161.316 32.6169 160.518 34.7802 158.901 36.4028C157.284 37.982 155.063 38.7825 152.26 38.7825ZM152.389 25.283C151.182 25.283 150.233 25.6941 149.564 26.5378C148.896 27.3815 148.551 28.5497 148.551 30.0857C148.551 33.2875 149.845 34.8668 152.411 34.8668C154.869 34.8668 156.076 33.2226 156.076 29.9559C156.098 26.819 154.869 25.283 152.389 25.283Z",
    fill: "#1A1A1A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M190.943 38.3716H185.854V28.896C185.854 26.473 184.97 25.2832 183.202 25.2832C182.361 25.2832 181.671 25.651 181.153 26.3649C180.614 27.1004 180.356 27.9874 180.356 29.0691V38.3716H175.245V28.7878C175.245 26.4298 174.383 25.2616 172.636 25.2616C171.752 25.2616 171.062 25.6077 170.545 26.3C170.027 26.9922 169.769 27.9441 169.769 29.134V38.3716H164.658V21.7353H169.769V24.3313H169.833C170.372 23.4443 171.105 22.7304 172.054 22.1679C173.003 21.6055 174.059 21.3242 175.181 21.3242C177.531 21.3242 179.127 22.3626 179.989 24.4178C181.261 22.341 183.116 21.3242 185.552 21.3242C189.153 21.3242 190.964 23.5525 190.964 28.009V38.3716H190.943Z",
    fill: "#1A1A1A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M200.171 36.4457H200.106V38.3711H194.996V13.752H200.106V24.2443H200.171C201.443 22.2973 203.233 21.3454 205.562 21.3454C207.696 21.3454 209.335 22.0809 210.499 23.552C211.664 25.0231 212.224 27.0351 212.224 29.5878C212.224 32.3569 211.556 34.5852 210.198 36.2726C208.839 37.9601 207.049 38.7822 204.785 38.7822C202.78 38.7822 201.228 38.0033 200.171 36.4457ZM200.042 29.4364V31.1455C200.042 32.2271 200.344 33.1141 200.969 33.8064C201.594 34.5203 202.37 34.8665 203.341 34.8665C204.505 34.8665 205.411 34.4121 206.058 33.5035C206.705 32.5949 207.028 31.3185 207.028 29.6527C207.028 28.2682 206.726 27.2081 206.144 26.4293C205.562 25.6505 204.721 25.2611 203.621 25.2611C202.586 25.2611 201.745 25.6505 201.077 26.4077C200.365 27.1865 200.042 28.2033 200.042 29.4364Z",
    fill: "#1A1A1A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M238.855 38.3698H235.836L233.378 31.8364H223.546L221.238 38.3698H218.22L227.125 15.0703H229.95L238.855 38.3698ZM232.494 29.3918L228.85 19.462C228.721 19.1375 228.613 18.6182 228.483 17.9043H228.419C228.311 18.575 228.182 19.0942 228.052 19.462L224.451 29.3918H232.494Z",
    fill: "url(#paint0_linear_2978_17908)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M245 38.3701H242.283V15.0922H245V38.3701Z",
    fill: "url(#paint1_linear_2978_17908)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1106 9.84334H27.6228L26.48 0H30.2534L29.1106 9.84334Z",
    fill: "url(#paint2_linear_2978_17908)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1887 10.9261L20.8302 11.4886L16.0434 2.81344L19.5149 1.36398L22.1887 10.9261Z",
    fill: "url(#paint3_linear_2978_17908)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6376 10.0396L24.1714 10.3209L21.1742 0.866937L24.8829 0.153025L25.6376 10.0396Z",
    fill: "url(#paint4_linear_2978_17908)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0737 40.2387L16.1302 41.2771L9.98493 49.0652L7.31119 46.3826L15.0737 40.2387Z",
    fill: "url(#paint5_linear_2978_17908)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7198 44.3702L22.0783 44.9543L19.3398 54.4731L15.8683 53.0237L20.7198 44.3702Z",
    fill: "url(#paint6_linear_2978_17908)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6609 42.5548L18.8899 43.3985L14.3618 52.2034L11.2353 50.0833L17.6609 42.5548Z",
    fill: "url(#paint7_linear_2978_17908)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1274 14.6267L15.0708 15.6868L7.30833 9.52115L9.98207 6.83857L16.1274 14.6267Z",
    fill: "url(#paint8_linear_2978_17908)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.796 17.2225L12.9766 18.4556L4.1791 13.9125L6.29222 10.7756L13.796 17.2225Z",
    fill: "url(#paint9_linear_2978_17908)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0575 12.4207L17.8069 13.2427L11.4675 5.62768L14.6157 3.55084L19.0575 12.4207Z",
    fill: "url(#paint10_linear_2978_17908)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.5724 40.3714L40.5158 41.4315L46.7043 49.2845L49.3996 46.5803L41.5724 40.3714Z",
    fill: "url(#paint11_linear_2978_17908)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.771 44.6118L34.3694 45.1742L37.0647 54.8229L40.601 53.3734L35.771 44.6118Z",
    fill: "url(#paint12_linear_2978_17908)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7898 42.8388L37.5392 43.6609L42.0242 52.6172L45.2154 50.5187L38.7898 42.8388Z",
    fill: "url(#paint13_linear_2978_17908)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8919 46.2537H27.4041L26.2397 56.2052H30.0563L28.8919 46.2537Z",
    fill: "url(#paint14_linear_2978_17908)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3624 45.7767L30.8962 46.058L31.6724 56.0528L35.4027 55.3172L32.3624 45.7767Z",
    fill: "url(#paint15_linear_2978_17908)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7387 45.7346L25.2049 46.0375L24.3208 56.0106L20.5905 55.2534L23.7387 45.7346Z",
    fill: "url(#paint16_linear_2978_17908)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9952 34.2053L11.5558 35.6115L2.82302 40.4574L1.37834 36.9311L10.9952 34.2053Z",
    fill: "url(#paint17_linear_2978_17908)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1112 30.723L10.3915 32.2157L0.882476 35.2445L0.149352 31.5018L10.1112 30.723Z",
    fill: "url(#paint18_linear_2978_17908)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5042 37.3864L13.3235 38.6411L5.66887 45.088L3.57731 41.9078L12.5042 37.3864Z",
    fill: "url(#paint19_linear_2978_17908)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.91873 27.2188V28.7115L0 29.8797V26.0505L9.91873 27.2188Z",
    fill: "url(#paint20_linear_2978_17908)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6211 20.2112L11.0389 21.5957L1.44359 18.8266L2.90983 15.3003L11.6211 20.2112Z",
    fill: "url(#paint21_linear_2978_17908)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.436 23.5412L10.1342 25.0123L0.193872 24.1253L0.948558 20.3827L10.436 23.5412Z",
    fill: "url(#paint22_linear_2978_17908)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6256 10.9685L36.0056 11.5309L40.8572 2.87746L37.3641 1.428L34.6256 10.9685Z",
    fill: "url(#paint23_linear_2978_17908)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8184 12.5246L39.0475 13.3466L45.4947 5.8181L42.3681 3.698L37.8184 12.5246Z",
    fill: "url(#paint24_linear_2978_17908)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2851 10.0581L32.7298 10.361L35.8348 0.95035L32.1476 0.19317L31.2851 10.0581Z",
    fill: "url(#paint25_linear_2978_17908)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5991 14.6247L41.6341 15.6847L49.3966 9.51911L46.7228 6.83653L40.5991 14.6247Z",
    fill: "url(#paint26_linear_2978_17908)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.3816 27.2158V28.7085L56.3003 29.8767V26.0475L46.3816 27.2158Z",
    fill: "url(#paint27_linear_2978_17908)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7219 20.3145L45.3041 21.7207L54.921 19.0165L53.4763 15.4685L44.7219 20.3145Z",
    fill: "url(#paint28_linear_2978_17908)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2604 34.3328L44.6782 35.7173L53.3895 40.6282L54.8557 37.1019L45.2604 34.3328Z",
    fill: "url(#paint29_linear_2978_17908)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9079 23.7317L46.1882 25.2028L56.15 24.424L55.4169 20.6813L45.9079 23.7317Z",
    fill: "url(#paint30_linear_2978_17908)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6865 37.5569L42.8456 38.8116L50.4356 45.3234L52.5702 42.1648L43.6865 37.5569Z",
    fill: "url(#paint31_linear_2978_17908)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9749 17.2857L43.7943 18.5404L52.7211 14.0406L50.6296 10.8388L42.9749 17.2857Z",
    fill: "url(#paint32_linear_2978_17908)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1442 30.9148L45.8424 32.3859L55.3298 35.5445L56.1061 31.8018L46.1442 30.9148Z",
    fill: "url(#paint33_linear_2978_17908)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6792 16.0527L21.9492 29.8334H29.453L33.6792 16.0527Z",
    fill: "url(#paint34_linear_2978_17908)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6094 40.4779L35.3178 26.6973H27.8141L23.6094 40.4779Z",
    fill: "url(#paint35_linear_2978_17908)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2978_17908",
    x1: 247,
    y1: 15.5,
    x2: 225.286,
    y2: 37.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2978_17908",
    x1: 247,
    y1: 15.5,
    x2: 225.286,
    y2: 37.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2978_17908",
    x1: 48.0702,
    y1: 8.23353,
    x2: 8.3167,
    y2: 48.0599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2978_17908",
    x1: 31.9645,
    y1: 18.0715,
    x2: 22.3424,
    y2: 26.2628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2978_17908",
    x1: 33.6062,
    y1: 28.716,
    x2: 23.987,
    y2: 36.8899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202884,
    stopColor: "#92E7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.312261,
    stopColor: "#45D5DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395596,
    stopColor: "#49BDDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640392,
    stopColor: "#768CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801853,
    stopColor: "#6D72F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D72F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoulombLogo);
export default __webpack_public_path__ + "static/media/CoulombLogo.354c53328254b12d1916cf07ec0f3427.svg";
export { ForwardRef as ReactComponent };